import { call, put, takeLatest, all } from 'redux-saga/effects'

import { logException } from '~/logging'
import { updateAddressBookSuccess, updateAddressBookFailure, ACTIONS } from './actions'
import { queryAddressBook } from './AddressService'
import { AddressBookEntry } from './reducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* handleUpdateAddressBookRequested(action: any) {
  const searchTerm = action.payload

  try {
    const addresses: AddressBookEntry[] = yield call(queryAddressBook, searchTerm, null, null, true)

    yield put(updateAddressBookSuccess(addresses))
  } catch (error) {
    logException(error)
    if (error instanceof Error) {
      yield put(updateAddressBookFailure(error))
    }
  }
}
export function* addressBookSaga() {
  yield all([takeLatest(ACTIONS.UPDATE_ADDRESSBOOK_REQUESTED, handleUpdateAddressBookRequested)])
}
